export default __webpack_public_path__ + "static/media/hello.3b613f5c.png";